import script from "./CallInteractionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallInteractionPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CallInteractionPanel.vue?vue&type=style&index=0&id=3e0df42a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e0df42a"]])

export default __exports__